import {
	Outlet,
	createFileRoute,
	useLocation,
	useNavigate,
} from "@tanstack/react-router";
import { useMemo } from "react";
import { ChevronLeftIcon } from "~/components/icons";

import { authStore } from "@/lib/auth/store";
import { cn, formatThousands } from "@/lib/utils";
import { m } from "@/paraglide/messages";
import { localizeHref } from "@/paraglide/runtime";
import { useStore } from "@tanstack/react-store";
import { navs } from "~/components/business/profileNav";
export const Route = createFileRoute("/$lang/profile")({
	component: ProfileLayout,
});

import { ProfileNav } from "@/components/business/profileNav";
import { GemIcon2 } from "~/components/icons";

function ProfileLayout() {
	const location = useLocation();
	const navigate = useNavigate();
	const user = useStore(authStore, (s) => s.user);

	const isProfileRoot = useMemo(
		() => location.pathname === localizeHref("/profile"),
		[location.pathname],
	);

	return (
		<div className="max-w-[1172px] mx-auto">
			<div className="text-[32px] font-medium text-t1 mb-[18px] w-full md:block hidden">
				{m.profile()}
			</div>
			<div className="flex items-start min-h-[80vh] w-full">
				{/* 左侧导航 */}
				<div className="flex flex-col items-center gap-4 max-md:min-w-full max-md:px-4">
					<div className="md:hidden flex flex-col items-center gap-2">
						<div className="border-5 w-25 h-25 rounded-full overflow-hidden">
							<img
								src={user?.avatar}
								className="w-full h-full object-cover"
								alt="avatar"
							/>
						</div>
						<div className="flex items-center gap-1">
							<GemIcon2 className="w-4.5 h-4.5" />
							{formatThousands(user?.gem ?? 0)}
						</div>
					</div>

					<ProfileNav />
				</div>

				{/* 右侧内容 */}
				<div
					className={cn(
						"flex-1 bg-card md:rounded-[20px] md:ml-2 shadow-card max-w-[959px] transition-all duration-300 max-md:fixed max-md:top-0 max-md:z-50 max-md:w-full max-md:h-full max-md:left-[100vw]",
						isProfileRoot ? "max-md:left-[100vw]" : "max-md:left-0",
					)}
				>
					<div className="md:hidden flex items-center justify-between">
						<div className="text-t1 text-base font-normal flex items-center w-full px-4 h-13.5">
							<ChevronLeftIcon
								className="w-4 h-4 relative z-10"
								onClick={() => {
									console.log("click");
									navigate({ to: localizeHref("/profile") });
								}}
							/>
							<span className="text-t1 flex-1 text-center -ml-4">
								{
									navs.find(
										(item) => item.path === location.pathname.split("/").pop(),
									)?.label
								}
							</span>
						</div>
					</div>
					<Outlet />
				</div>
			</div>
		</div>
	);
}
